import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  CodigoReserva!: number;
  isRequest: any;

  done: AnimationOptions = {
    path: './assets/json/done.json',
    loop: false
  };

  habilitarRedirecionamentoIMOB : boolean = false;
  linkImob;

  constructor(public translateService: TranslateService) {
    this.CodigoReserva = history.state.CodigoReserva;
    this.habilitarRedirecionamentoIMOB = sessionStorage.getItem('habilitarRedirecionamentoIMOB') == 'S'
    this.linkImob = sessionStorage.getItem('linkImob')
  }

  ngOnInit(): void {
    this.isRequest = sessionStorage.getItem('modoUtilizacao')
    if(this.linkImob)
    this.redirecionarImob(this.linkImob)
  }

  redirecionarImob(linkImob: string) {
    if (this.habilitarRedirecionamentoIMOB && linkImob) {
      Swal.fire({
        title: this.translateService.instant('TXT_IMOB_REDIRECT'),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
        timer: 2000,
        timerProgressBar: true
      }).then(() => {
        window.location.href = linkImob;
      });
    }
  }
}
